// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:100,300,400,700);"]);
exports.push([module.id, "@import url(https://use.fontawesome.com/releases/v5.0.7/css/all.css);"]);
// Module
exports.push([module.id, "", ""]);
// Exports
module.exports = exports;
